import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../lib/utils';

export const ModelCard = ({ Icon, name, color }) => (
  <motion.div
    className={cn(
      "relative w-20 h-16 cursor-pointer overflow-hidden rounded-lg border p-2.5",
      "border-gray-950/[.1] bg-gray-950/[.01] hover:bg-gray-950/[.05]",
      "dark:border-gray-50/[.1] dark:bg-gray-50/[.10] dark:hover:bg-gray-50/[.15]",
      "transform-gpu blur-[1px] transition-all duration-300 ease-out",
      "group-hover:blur-none group-hover/icons:blur-none hover:blur-none",
    )}
    whileHover={{ y: -2 }}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
  >
    {/* 品牌色彩背景渐变 */}
    <div className={`absolute inset-0 bg-gradient-to-br ${color} opacity-[0.02] transition-opacity duration-300 group-hover:opacity-[0.08] group-hover/icons:opacity-[0.08] hover:opacity-[0.08]`} />
    
    {/* 图标和标题 */}
    <div className="relative z-10 flex flex-col items-center justify-center h-full gap-1">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
        <Icon size={16} />
      </div>
      <span className="text-[10px] font-medium text-gray-700 dark:text-gray-300 text-center leading-tight truncate w-full">
        {name}
      </span>
    </div>
  </motion.div>
); 